var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.759277H513V114.759H0V0.759277Z",
    fill: "#20AA46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.759H513V342.759H0V228.759Z",
    fill: "#E92F3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 114.759H513V228.759H0V114.759Z",
    fill: "#FADF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.631 290.315C323.11 290.315 376.191 237.234 376.191 171.755C376.191 106.276 323.11 53.1948 257.631 53.1948C192.152 53.1948 139.071 106.276 139.071 171.755C139.071 237.234 192.152 290.315 257.631 290.315Z",
    fill: "#205CCA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.64 76.8853L279.932 140.976H352.947L294.019 183.067L316.47 250.422L257.64 208.401L198.809 250.422L221.293 182.971L165.3 140.976H235.292L236.272 138.033L236.361 138.063L257.64 76.8853ZM231.492 152.376L225.093 171.571L199.5 152.376H231.492ZM231.014 189.859L220.71 220.769L246.889 202.071L231.014 189.859ZM267.47 201.412L294.569 220.769L284.268 189.864L267.47 201.412ZM291.025 171.196L317.373 152.376H283.706L291.025 171.196ZM267.862 140.976L257.64 111.586L247.417 140.976H267.862ZM243.508 152.376L234.83 178.412L256.526 195.102L281.431 177.98L271.474 152.376H243.508Z",
    fill: "#FFDB3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.423 122.361L312.223 85.8809L317.057 88.9019L294.257 125.382L289.423 122.361ZM221.091 127.766L196.011 91.286L200.708 88.0568L225.788 124.537L221.091 127.766ZM160.847 203.295L201.887 187.335L203.953 192.648L162.913 208.608L160.847 203.295ZM313.393 187.335L354.433 203.295L352.367 208.608L311.327 192.648L313.393 187.335ZM254.79 274.351V231.031H260.49V274.351H254.79Z",
    fill: "#FFDB3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.759277)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/ET.eb2993aab13c80d998b0e081c5d6f24c.svg";
export { ForwardRef as ReactComponent };